// providers/AppProviders.js

import React from "react";
import { UserProvider } from "../context/user";
import { useAppStore } from "../store/appStore";

export const AppProviders = ({ children }) => {
  const sessionValidated = useAppStore((s) => s.sessionValidated);
  const rehydrated = useAppStore((s) => s.rehydrated);

  if (!sessionValidated || !rehydrated) {
    return <div className="app-loading">Initializing application...</div>;
  }

  return <UserProvider>{children}</UserProvider>;
};
